import IFormInput, { IFormInputVisibilityConstraint } from '@frontend/types/modules/form/IFormInput';

/**
 * Validates if all constraints to make an input visible are fulfilled
 * @protected
 */
export function areVisibilityContraintsFulfilled(field: IFormInput, inputs: IFormInput[]): boolean {
	// ignore visibility constraints with empty field names
	const visibilityConstraints = field.visibilityConstraints
		? field.visibilityConstraints.filter((constraint): boolean => !!constraint.fieldName)
		: undefined;

	if (!visibilityConstraints || visibilityConstraints.length === 0) {
		return true;
	}

	let allVisibilityContraintsFulfilled: boolean = true;

	visibilityConstraints.forEach((constraint: IFormInputVisibilityConstraint): void => {
		const dependentInput: IFormInput | undefined = inputs.find((input): boolean => input.name === constraint.fieldName);

		if (!dependentInput || dependentInput.value === undefined || dependentInput.value === null) {
			allVisibilityContraintsFulfilled = false;
		} else if (typeof dependentInput.value === 'boolean') {
			if (['1', 'true', 'yes', 'ja'].includes(constraint.value.toLowerCase())) {
				if (!dependentInput.value) {
					allVisibilityContraintsFulfilled = false;
				}
			} else if (dependentInput.value) {
				allVisibilityContraintsFulfilled = false;
			}
		} else if (typeof dependentInput.value === 'string' || typeof dependentInput.value === 'number') {
			const dependencyValue: string = dependentInput.value.toString();

			if (!(dependencyValue === constraint.value || dependencyValue.match(new RegExp(constraint.value, 'i')))) {
				allVisibilityContraintsFulfilled = false;
			}
		}
	});

	return allVisibilityContraintsFulfilled;
}
